import React from 'react';
import { PaymentSecureInfoWrapper, PaymentSecureInfoWrapperRow } from './SecureInfo.styled';
import Visa from './SVG/Visa.svg';
import Discover from './SVG/Discover.svg';
import American from './SVG/American.svg';
import MasterCard from './SVG/MasterCard.svg';
import SSLSecure from './SVG/SSLSecure.svg';
import PoweredByStripe from './SVG/PoweredByStripe.svg';
import { FormattedMessage } from 'react-intl';

type SecureInfoProps = {
  order?: 'text-first' | 'text-last';
};

export const SecureInfo: React.FC<SecureInfoProps> = ({ order = 'text-first' }) => {
  return order === 'text-first' ? (
    <PaymentSecureInfoWrapper>
      <PaymentSecureInfoWrapperRow>
        <FormattedMessage
          id={'stripe.text'}
          defaultMessage={
            "Усі платежі надійно обробляються Stripe – найбезпечнішою системою платежів у світі. Пам'ятайте, Mindly ніколи не зберігає дані твоєї банківської картки."
          }
        />
      </PaymentSecureInfoWrapperRow>
      <PaymentSecureInfoWrapperRow>
        <img src={PoweredByStripe} alt="PoweredByStripe" />
        <img src={SSLSecure} alt="SSLSecure" />
      </PaymentSecureInfoWrapperRow>
      <PaymentSecureInfoWrapperRow className={'cards'}>
        <img src={Visa} alt="Visa" />
        <img src={MasterCard} alt="MasterCard" />
        <img src={Discover} alt="Discover" />
        <img src={American} alt="American" />
      </PaymentSecureInfoWrapperRow>
    </PaymentSecureInfoWrapper>
  ) : (
    <PaymentSecureInfoWrapper>
      <PaymentSecureInfoWrapperRow>
        <img src={PoweredByStripe} alt="PoweredByStripe" />
        <img src={SSLSecure} alt="SSLSecure" />
      </PaymentSecureInfoWrapperRow>
      <PaymentSecureInfoWrapperRow className={'cards'}>
        <img src={Visa} alt="Visa" />
        <img src={MasterCard} alt="MasterCard" />
        <img src={Discover} alt="Discover" />
        <img src={American} alt="American" />
      </PaymentSecureInfoWrapperRow>
      <PaymentSecureInfoWrapperRow>
        <FormattedMessage
          id={'stripe.text'}
          defaultMessage={
            "Усі платежі надійно обробляються Stripe – найбезпечнішою системою платежів у світі. Пам'ятайте, Mindly ніколи не зберігає дані твоєї банківської картки."
          }
        />
      </PaymentSecureInfoWrapperRow>
    </PaymentSecureInfoWrapper>
  );
};
